require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-el-salvador-covid-19-emergency-response.json") })
        }
      }, "path---en-us-project-el-salvador-covid-19-emergency-response");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-el-salvador-covid-19-emergency-response!./.cache/json/en-us-project-el-salvador-covid-19-emergency-response.json
// module id = 502
// module chunks = 231608221292675